export default class Constants {
  static ContactUsPagePath = 'contact-us';
}
